export const DOCUMENT_TYPE_PARTNER = 'partner';
